type IconProps = {
  className?: string;
};

export const NewOrdersIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6669 2.77772L15.5558 2.22217L14.4447 2.77772L13.3336 2.22217L12.2224 2.77772L11.1113 2.22217L10.0002 2.77772L8.88911 2.22217L7.77799 2.77772L6.11133 2.22217V11.1111V11.1128H13.8891V15.8333C13.8891 16.9072 15.0374 17.7777 16.1113 17.7777H16.528C17.602 17.7777 18.3336 16.9072 18.3336 15.8333V2.22217L16.6669 2.77772ZM10.5731 9.44439L10.5558 8.33328H16.094L16.1113 9.44439H10.5731ZM8.35091 6.66661L8.33355 5.5555H16.094L16.1113 6.66661H8.35091Z"
      fill="currentColor"
    />
    <path
      d="M12.7776 15.8333V12.2222H1.6665V13.3333C1.6665 15.0885 1.8672 15.8201 2.16859 16.376C2.68005 17.3194 3.60609 17.7777 4.99984 17.7777H13.8887C13.8887 17.7777 12.7776 17.0833 12.7776 15.8333Z"
      fill="currentColor"
    />
  </svg>
);
